import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getContactsListRequest } from "../../../reducers/company/companyMarketingSolution.reducer";
import { rootReducersState } from "../../../reducers";
import _ from "lodash";
import Contacts from "./contacts";
import { useNavigate } from "react-router-dom";
import appRoutes from "../../../routes/app.routes";
import { Button, CompanyPage } from "../../../components/common";

const pageSize = 50;

export const ContactHeaderActions = () => {
  const navigate = useNavigate();
  const sessionReducer = useSelector(
    ({ session }: rootReducersState) => session
  );
  const companySlug = sessionReducer.currentCompany.slug;

  return (
    <Button
      onClick={() =>
        navigate(appRoutes.emailCampaign.generatePath(companySlug))
      }
    >
      Create Campaign
    </Button>
  );
};

const ContactList = ({ embedded = false }: { embedded?: boolean }) => {
  const [page, setPage] = useState(1);
  const marketingSolutionData = useSelector(
    ({ company }: rootReducersState) => company.companyMarketingSolution
  );
  const [contactList, setContactList] = useState([]);
  const [fetching, setFetching] = useState(false);
  const pagination = _.get(marketingSolutionData, "contactList.pagination", {});
  const contactListCount = _.get(pagination, "totalPages", 0);
  const dispatch = useDispatch();

  useEffect(() => {
    const updatedContactList = _.get(marketingSolutionData, "contactList.data", []);
    const loading = _.get(marketingSolutionData, "loading", false);
    setFetching(loading);
    setContactList(updatedContactList);
  }, [marketingSolutionData]);

  useEffect(() => {
    dispatch(getContactsListRequest({ page, pageSize }))
  }, [page, dispatch]);


  const fetchContactsForPage = (currentPage) => {
    dispatch(getContactsListRequest({ currentPage, pageSize }));
  };

  const content = (
      <Contacts
        contactList={contactList}
        setContactList={setContactList}
        page={page}
        setPage={setPage}
        count={contactListCount}
        fetchContactsForPage={fetchContactsForPage}
        isFetching={fetching}
      />
  );

  if (embedded) {
    return content;
  }

  return (
    <CompanyPage
      className="page-marketing"
      padded={false}
      header={
        <CompanyPage.HeaderRight>
          <ContactHeaderActions />
        </CompanyPage.HeaderRight>
      }
    >
      {content}
    </CompanyPage>
  );
};

export default ContactList;
